import type { PageCard } from '@/play/pageTypes'
import { Splat2CardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'splat-2',
  number: 34,
  title: 'Splat 2',
  question: 'With paint pots to choose from and a studio to splat in, does dropping paint feel like making a splatter painting?',
  status: 'open',
  // The newest version of 012 Splat (docs/pages.md, Versions).
  versionOf: 'splat',
  accent: '#f3e3cc',
  CardArt: Splat2CardArt,
}
